import * as swcHelpers from '@swc/helpers';

const mapVariantsToPowerItems = (variants)=>variants.filter((variant)=>variant.isPublished
    ).sort((a, b)=>+a.power - +b.power
    ).reduce((acc, { sku , power  })=>swcHelpers.objectSpread({}, acc, {
            [power]: {
                label: power,
                value: sku
            }
        })
    , {})
;

export { mapVariantsToPowerItems };
//# sourceMappingURL=map-variants-to-power-items.js.map
